<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <p class="title-bk">{{ title }}</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="javascript:;" @click="$router.go(-1)">
        戻る
      </a>
    </div>
    <div class="container">
      <div class="form-group float-right">
        <label for="text1">検索:</label>
        <input type="text" id="searchform_small" class="form-control" v-model="tableFilter" />
      </div>
      <form class="form-inline showall">
        <div class="form-sort align-items-center">
          <div class="item-count col-2 my-1">
            <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
              Preference
            </label>
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
              <option :value="totalItems" selected>全</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="150">150</option>
            </select>
            件表示
          </div>
        </div>
      </form>
      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="choice-table">
            <b-table
              ref="choice-table"
              :min-width="tableWidth"
              class="sticky-table"
              responsive
              hover
              sticky-header
              :filter="tableFilter"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isFetching"
              empty-text="表示するレコードはありません"
              show-empty
            >
              <!-- TODO: Setup passing slot cell form parent for individual case  -->
              <template #cell(testPassingScore)="row">{{ row.value }}点</template>

              <template #cell(choiceResource)="row">
                <div class="b-table-column-background-white">
                  <span class="link-fake" @click="choiceResource(row.item)">選択</span>
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>データのロード...</strong>
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ totalItems }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
                次
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateMinWidth } from '@/helpers/sticky_table';

export default {
  props: {
    resourceType: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      resoureTypes: ['corporation', 'brand', 'school', 'course', 'teacher', 'class'],
      tableFilter: null,
      currentPage: 1,
      perPage: this.totalItems,
    };
  },
  created() {
    if (this.prevRouteName == null) {
      this.$logger.debug('[FormChoice] Route Name invalid');
      this.$router.push({ name: 'home' });
    }
  },
  mounted() {
    this.perPage = this.totalItems;
    updateMinWidth();
  },
  computed: {
    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalItems);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalItems > this.currentPage * this.perPage;
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    ...mapState('form', ['modelFieldName', 'prevFormData', 'prevRouteName']),
  },
  methods: {
    choiceResource(resourceData) {
      this.$logger.debug('resourceData', resourceData);
      this.setModelFieldName(resourceData);
      this.$router.push({ path: this.prevRouteName });
    },
    goToPreviousPage() {
      this.currentPage--;
    },
    goToNextPage() {
      this.currentPage++;
    },
    ...mapActions('form', ['setModelFieldName']),
  },
  watch: {
    totalItems: function () {
      this.perPage = this.totalItems;
    },
  },
};
</script>

<style scoped>
.b-table-sticky-header {
  max-height: 600px;
}

.choice-table ::v-deep .table td {
  background-color: transparent;
}
</style>
